import React, { useState, useEffect } from 'react';
import axios from 'axios';
import classnames from 'classnames';
import dayjs from 'dayjs';
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  ModalFooter,
  Label,
} from 'reactstrap';
import PageBreadcrumb from '../../Components/Common/PageBreadcrumb';
import { useParams, useNavigate } from 'react-router-dom';
import RequirementTab from './RequirementTab';
import SupportDocumentTab from './SupportDocumentTab';
import ProcurementGtcTab from '../../shared/offer-domain/procurement/ProcurementGtcTab';
import { api } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import metaMask from '../../assets/images/nft/newrecord.png';
import Swal from 'sweetalert2';
import notify from '../../utils/notify';
import ActionButton from '../../Components/Common/ActionButton';
import { DetailBackButton } from '../../Components/Common/Detail';
import { Skeleton, SkeletonCard } from '../../Components/Common/Skeleton';
import useAsyncAction from '../../Components/Hooks/useAsyncAction';

axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

const InvitationForm = () => {
  const token = getAuthToken();
  const navigate = useNavigate();
  const { id } = useParams();
  const modalWidth = '415px';

  const [isLoading, setIsLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(true);
  const [activeTab, setactiveTab] = useState(1);
  const [error] = useState(null);
  const [errors, setErrors] = useState({});
  const [formMain, setFormMain] = useState({});
  const [form, setForm] = useState({
    procurementNumber: '',
    titleProcurement: '',
    updatedDate: '',
    createdDate: '',
  });

  const [modal_handleInvitationAccept, setmodal_handleInvitationAccept] =
    useState(false);
  const [modal_handleInvitationDecline, setmodal_handleInvitationDecline] =
    useState(false);
  const [modal_togSecond, setmodal_togSecond] = useState(false);
  const [declineReasonFormData, setDeclineReasonFormData] = useState({
    reasonDecline: null,
  });

  const fetchDataInvitation = async (invitationId, authToken) => {
    setIsLoading(true);
    let hasProcurement = false;
    try {
      const response = await axios.get(
        `${api.API_URL}/dmut/get-invitation?id=${invitationId}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
          },
        }
      );
      const firstItem = response.items[0];
      setFormMain({
        id: firstItem.procurementId || firstItem.id,
        statusInvitation: firstItem.statusInvitation,
        statusInvitationWording: firstItem.statusInvitationWording,
        // Hanya Open yang bisa Accept/Regret. Past Deadline → tombol disabled.
        statusInvitationFlag: firstItem.statusInvitationWording !== 'Open',
      });
      hasProcurement = Boolean(firstItem.procurementId || firstItem.id);
    } finally {
      setIsLoading(false);
      if (!hasProcurement) setIsDetailLoading(false);
    }
  };

  const fetchDataProcurement = async (procurementId, authToken) => {
    setIsLoading(true);
    try {
      const data = await axios.get(
        `${api.API_URL}/procurement/${procurementId}`,
        {
          withXSRFToken: true,
          headers: {
            Authorization: `Bearer ${authToken}`,
            Accept: 'application/json',
          },
        }
      );
      setForm({
        procurementNumber: data.procurementNumber || null,
        statusProcurement: data.statusProcurement || null,
        titleProcurement: data.titleProcurement || null,
        description: data.description || null,
        procurementType: data.procurementType || null,
        contractType: data.contractType || null,
        contractPeriodSpot: data.contractPeriodSpot || null,
        contractPeriodTermStart: data.contractPeriodTermStart || null,
        contractPeriodTermEnd: data.contractPeriodTermEnd || null,
        productTypeId: data.productTypeId || null,
        productType: data.productType || null,
        procurementProductTypes:
          data.procurementProductTypes ?? data.ProcurementProductTypes ?? [],
        productName: data.productType?.product?.name || null,
        productNameId: data.productType?.product?.id || null,
        operationalTolerance: data.operationalTolerance || null,
        partyType: data.partyType || null,
        productSpecification: data.productSpecification || null,
        ratioLpgId: data.ratioLpgId || null,
        ratioLpg: data.ratioLpg || null,
        refPropaneFrequency: data.refPropaneFrequency || null,
        refPropaneRangeQuantityFrom: data.refPropaneRangeQuantityFrom || null,
        refPropaneRangeQuantityTo: data.refPropaneRangeQuantityTo || null,
        refButaneFrequency: data.refButaneFrequency || null,
        refButaneRangeQuantityFrom: data.refButaneRangeQuantityFrom || null,
        refButaneRangeQuantityTo: data.refButaneRangeQuantityTo || null,
        notesForQuantityAndDeliveryTerms:
          data.notesForQuantityAndDeliveryTerms || null,
        globalNotes: data.globalNotes || null,
        quantityDiscrepancy: data.quantityDiscrepancy || null,
        delayPenaltyTerms: data.delayPenaltyTerms || null,
        delivery: data.delivery || null,
        nominationProcedure: data.nominationProcedure || null,
        firstTimeSupply: data.firstTimeSupply || null,
        redChannelPolicy: data.redChannelPolicy || null,
        deliveryCustom: data.deliveryCustom || null,
        invoicingQuantityId: data.invoicingQuantityId || null,
        invoicingQuantity: data.invoicingQuantity || null,
        modeInvoicingQuantityId: data.modeInvoicingQuantityId || null,
        modeInvoicingQuantity: data.modeInvoicingQuantity || null,
        descriptionOfPaymentTerms: data.descriptionOfPaymentTerms || null,
        paymentCurrencyId: data.paymentCurrencyId || null,
        paymentCurrency: data.paymentCurrency || null,
        lawId: data.lawId || null,
        law: data.law || null,
        arbitrationId: data.arbitrationId || null,
        arbitration: data.arbitration || null,
        notesForLoadingPort: data.notesForLoadingPort || null,
        portRestriction: data.portRestriction || [],
        procurementClauseDetails: data.procurementClauseDetails || [],
        otherTermsAndCondition: data.otherTermsAndCondition || null,
        additionalNotes: data.additionalNotes || null,
        proposalSubmissionDeadline: data.proposalSubmissionDeadline
          ? dayjs(data.proposalSubmissionDeadline).toDate()
          : null,
        proposalValidityPeriodMax: data.proposalValidityPeriodMax
          ? dayjs(data.proposalValidityPeriodMax).toDate()
          : null,
        fileHasilOptimasiHilir: data.fileHasilOptimasiHilir || null,
        filePenetapanHargaDasarImpor: data.filePenetapanHargaDasarImpor || null,
        fileSpesifikasi: data.fileSpesifikasi || null,
        fileGeneralTermsAndConditions:
          data.fileGeneralTermsAndConditions || null,
        fileDocumentQ88: data.fileDocumentQ88 || null,
        fileDocumentGasFormC: data.fileDocumentGasFormC || null,
        fileSupporting1: data.fileSupporting1 || null,
        fileSupporting2: data.fileSupporting2 || null,
        fileSupporting3: data.fileSupporting3 || null,
        fileSupporting4: data.fileSupporting4 || null,
        fileSupporting5: data.fileSupporting5 || null,
        subStatus: data.subStatus || null,
        isInformationAboutDMUTConfirmed:
          data.isInformationAboutDMUTConfirmed || null,
        isAcknowledgedDMUT: data.isAcknowledgedDMUT || null,
        hpsRequestNumber: data.hpsRequestNumber || null,
        hpsRequestDate: data.hpsRequestDate || null,
        userId: data.userId || null,
        user: data.user || null,
        isProcurementRequirementCompleted:
          data.isProcurementRequirementCompleted || null,
        isSupportingDocumentsCompleted:
          data.isSupportingDocumentsCompleted || null,
        isDMUTInvitationCompleted: data.isDMUTInvitationCompleted || null,
        isHPSRequestCompleted: data.isHPSRequestCompleted || null,
        id: data.id || null,
        createdBy: data.createdBy || null,
        updatedBy: data.updatedBy || null,
        createdDate: data.createdDate || null,
        updatedDate: data.updatedDate || null,
        isDeleted: data.isDeleted || null,
        deletedDate: data.deletedDate || null,
        deletedBy: data.deletedBy || null,
        gtcs: data.gtcs || [],
      });
    } finally {
      setIsLoading(false);
      setIsDetailLoading(false);
    }
  };

  useEffect(() => {
    fetchDataInvitation(id, token);
  }, [id, token]);

  useEffect(() => {
    if (formMain.id) {
      fetchDataProcurement(formMain.id, token);
    }
  }, [formMain.id, token]);

  function toggleTab(tab) {
    if (activeTab !== tab && tab >= 1 && tab <= 3) {
      setactiveTab(tab);
    }
  }

  function handleInvitationAccept() {
    setmodal_handleInvitationAccept(!modal_handleInvitationAccept);
  }

  function handleInvitationDecline() {
    setmodal_handleInvitationDecline(!modal_handleInvitationDecline);
  }

  function tog_togSecond() {
    setDeclineReasonFormData({ reasonDecline: null });
    setmodal_togSecond(!modal_togSecond);
  }

  const handleInputTextChange = e => {
    const { name, value } = e.target;
    setDeclineReasonFormData({ ...declineReasonFormData, [name]: value });
  };

  // Interceptor axios me-reject dengan string message dari BE (mis. invitation sudah Closing).
  const showRespondError = err => {
    notify.apiError(err, 'respond to the invitation');
  };

  const [handleConfirmInvitationAccept, isAccepting] = useAsyncAction(
    async () => {
      try {
        await axios.post(
          `${api.API_URL}/dmut/respond-invitation?procurementMitraId=${id}&status=1&reasonDecline=${null}`,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Swal.fire({
          title: 'Invitation Accepted',
          text: 'You have successfully accepted the hydro product procurement invitation. You may now proceed to the offering and tender process',
          icon: 'success',
        });

        setmodal_togSecond(false);
        navigate('/apps-invitation/view');
      } catch (err) {
        showRespondError(err);
      }
    }
  );

  const [handleConfirmInvitationDecline, isDeclining] = useAsyncAction(
    async () => {
      try {
        await axios.post(
          `${api.API_URL}/dmut/respond-invitation?procurementMitraId=${id}&status=2&reasonDecline=${declineReasonFormData.reasonDecline}`,
          {},
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        Swal.fire({
          title: 'Invitation Declined',
          text: 'You have decline the hydro product procurement invitation. The Invitation will not proceed to the offering and tender process',
          icon: 'success',
        });
        setmodal_togSecond(false);
        navigate('/apps-invitation/view');
      } catch (err) {
        showRespondError(err);
      }
    }
  );

  document.title = 'Invitation Detail';

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <div className='email-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1'>
            <div className='email-content minimal-border'>
              <div className='p-4 pb-0'>
                <div className='border-bottom border-bottom-dashed'>
                  <Row className='mt-n2 mb-1 mb-sm-0'>
                    <div className='col-sm order-3 order-sm-2'>
                      <div className='hstack gap-sm-1 align-items-center flex-wrap email-topbar-link'>
                        <h5 className='card-title mb-0 flex-grow-1'>
                          <PageBreadcrumb
                            fallback={{
                              label: 'Invitation',
                              to: '/apps-invitation/view',
                            }}
                            current={`Detail #${form.procurementNumber || '-'}`}
                            listClassName='p-3 py-2 bg-light'
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                  <Row className='mb-4'>
                    <Col xs={12}>
                      <Row className='align-items-center g-3'>
                        <Col xs={12} lg>
                          <div>
                            <div className='dt-header__top'>
                              <DetailBackButton
                                label='Back to list'
                                onClick={() =>
                                  navigate('/apps-invitation/view')
                                }
                              />
                              {!isDetailLoading && (
                                <span
                                  className={`badge fw-bold px-3 py-1 rounded-pill ${
                                    formMain.statusInvitationWording === 'Open'
                                      ? 'bg-primary text-white'
                                      : formMain.statusInvitationWording ===
                                          'Accepted'
                                        ? 'bg-success text-white'
                                        : formMain.statusInvitationWording ===
                                            'Past Deadline'
                                          ? 'bg-warning text-dark'
                                          : formMain.statusInvitationWording ===
                                              'Closing'
                                            ? 'bg-secondary text-white'
                                            : 'bg-danger text-white'
                                  }`}
                                >
                                  {formMain.statusInvitationWording}
                                </span>
                              )}
                            </div>
                            {isDetailLoading ? (
                              <div role='status' aria-busy='true'>
                                <span className='visually-hidden'>Loading</span>
                                <Skeleton width={320} height={24} />
                                <Skeleton
                                  className='mt-2'
                                  width={220}
                                  height={14}
                                />
                              </div>
                            ) : (
                              <div>
                                <h4 className='mb-2 fw-bold text-dark text-break'>
                                  {form.titleProcurement}
                                </h4>
                                <div className='d-flex flex-wrap align-items-center gap-2 text-muted small'>
                                  <i className='ri-hashtag'></i>
                                  <span>
                                    Procurement ID:{' '}
                                    {form.procurementNumber || '-'}
                                  </span>

                                  <span className='d-none d-md-inline text-secondary opacity-25'>
                                    |
                                  </span>

                                  <i className='ri-calendar-line'></i>
                                  <span>
                                    {form.updatedDate || form.createdDate
                                      ? dayjs(
                                          form.updatedDate || form.createdDate
                                        ).format('DD MMM YYYY')
                                      : 'N/A'}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <hr className='mt-3 mb-0 border-secondary opacity-10' />
                    </Col>
                    <Col xs={12}>
                      <Card>
                        <CardBody className='checkout-tab'>
                          <Nav
                            tabs
                            className='nav-tabs-custom nav-primary mt-1 mb-3'
                          >
                            <NavItem>
                              <NavLink
                                tag='button'
                                type='button'
                                className={classnames('cursor-pointer', {
                                  active: activeTab === 1,
                                })}
                                onClick={() => toggleTab(1)}
                              >
                                <i className='ri-store-2-line me-2 align-middle'></i>
                                <span className='fw-semibold'>Invitation</span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                tag='button'
                                type='button'
                                className={classnames('cursor-pointer', {
                                  active: activeTab === 2,
                                })}
                                onClick={() => toggleTab(2)}
                              >
                                <i className='ri-file-text-line me-2 align-middle'></i>
                                <span className='fw-semibold'>
                                  Supporting Document
                                </span>
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                tag='button'
                                type='button'
                                className={classnames('cursor-pointer', {
                                  active: activeTab === 3,
                                })}
                                onClick={() => toggleTab(3)}
                              >
                                <i className='ri-scales-3-line me-2 align-middle'></i>
                                <span className='fw-semibold'>GTC</span>
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent activeTab={activeTab}>
                            <TabPane tabId={1} id='pills-bill-info'>
                              {isDetailLoading ? (
                                <>
                                  <SkeletonCard
                                    lines={5}
                                    className='border mb-4'
                                  />
                                  <SkeletonCard
                                    lines={6}
                                    className='border mb-4'
                                  />
                                  <SkeletonCard lines={4} className='border' />
                                </>
                              ) : (
                                <RequirementTab
                                  goNext={() => setactiveTab(2)}
                                  ids={formMain.id}
                                  formMain={formMain}
                                  setFormMain={setFormMain}
                                  form={form}
                                  setForm={setForm}
                                  errors={errors}
                                  error={error}
                                  setErrors={setErrors}
                                  setIsLoading={setIsLoading}
                                  token={token}
                                  handleInvitationDecline={
                                    handleInvitationDecline
                                  }
                                  handleInvitationAccept={
                                    handleInvitationAccept
                                  }
                                />
                              )}
                            </TabPane>
                            <TabPane tabId={2}>
                              <SupportDocumentTab
                                goBack={() => setactiveTab(1)}
                                ids={formMain.id}
                                formMain={formMain}
                                setFormMain={setFormMain}
                                form={form}
                                setForm={setForm}
                                token={token}
                                setIsLoading={setIsLoading}
                                isLoading={isLoading}
                                handleInvitationDecline={
                                  handleInvitationDecline
                                }
                                handleInvitationAccept={handleInvitationAccept}
                              />
                            </TabPane>
                            <TabPane tabId={3}>
                              {activeTab === 3 && (
                                <ProcurementGtcTab
                                  procurementId={formMain.id}
                                />
                              )}
                            </TabPane>
                          </TabContent>
                          {(formMain.statusInvitationWording === 'Open' ||
                            formMain.statusInvitationWording ===
                              'Past Deadline') && (
                            <div className='req-actionbar flex-wrap align-items-center justify-content-between gap-3'>
                              <div
                                className='flex-grow-1 me-2'
                                style={{ minWidth: 0 }}
                              >
                                {formMain.statusInvitationWording ===
                                'Past Deadline' ? (
                                  <div
                                    className='alert alert-warning py-2 px-3 mb-0 small text-break'
                                    role='status'
                                  >
                                    This invitation is past the proposal
                                    deadline. Accept and Regret are no longer
                                    available.
                                  </div>
                                ) : null}
                              </div>
                              <div className='d-inline-flex align-items-center gap-2 flex-wrap flex-shrink-0'>
                                <ActionButton
                                  variant='destructive'
                                  confirm={false}
                                  icon='ri-close-line'
                                  loading={isDeclining}
                                  disabled={
                                    formMain.statusInvitationWording !==
                                      'Open' || isAccepting
                                  }
                                  onClick={handleInvitationDecline}
                                >
                                  Regret
                                </ActionButton>
                                <ActionButton
                                  variant='primary'
                                  icon='ri-check-line'
                                  loading={isAccepting}
                                  disabled={
                                    formMain.statusInvitationWording !==
                                      'Open' || isDeclining
                                  }
                                  onClick={handleInvitationAccept}
                                >
                                  Accept
                                </ActionButton>
                              </div>
                            </div>
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Modal
        isOpen={modal_handleInvitationAccept}
        toggle={handleInvitationAccept}
        id='accept-modal'
        centered
      >
        <ModalHeader toggle={() => setmodal_handleInvitationAccept(false)} />
        <ModalBody className='text-center p-3 p-sm-5'>
          <div className='mt-1 pt-2'>
            <Row className='justify-content-center mb-1'>
              <Col lg={12} className='text-center'>
                <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
                <h5>Accept this invitation?</h5>
                <p className='text-muted pb-1'>
                  You will take part in the offering and tender process for this
                  hydro product procurement. Your response cannot be changed
                  after you accept.
                </p>
              </Col>
            </Row>
            <ActionButton
              variant='secondary'
              icon='ri-close-line'
              className='ms-2'
              onClick={() => setmodal_handleInvitationAccept(false)}
            >
              Cancel
            </ActionButton>
            <ActionButton
              variant='primary'
              icon='ri-database-2-line'
              className='ms-2'
              onClick={() => {
                handleConfirmInvitationAccept();
                setmodal_handleInvitationAccept(false);
              }}
            >
              Accept invitation
            </ActionButton>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modal_handleInvitationDecline}
        toggle={handleInvitationDecline}
        id='decline-modal'
        centered
      >
        <ModalHeader toggle={() => setmodal_handleInvitationDecline(false)} />
        <ModalBody className='text-center p-3 p-sm-5'>
          <div className='mt-1 pt-2'>
            <Row className='justify-content-center mb-1'>
              <Col lg={12} className='text-center'>
                <img src={metaMask} alt='' height='65' className='mb-2 pb-2' />
                <h5>Decline this invitation?</h5>
                <p className='text-muted pb-1'>
                  A declined invitation does not proceed to the offering and
                  tender process, and your response cannot be changed
                  afterwards. You can add a reason in the next step.
                </p>
              </Col>
            </Row>
            <ActionButton
              variant='secondary'
              icon='ri-close-line'
              className='ms-2'
              onClick={() => setmodal_handleInvitationDecline(false)}
            >
              Cancel
            </ActionButton>
            <ActionButton
              variant='primary'
              className='ms-2'
              onClick={() => {
                tog_togSecond();
                setmodal_handleInvitationDecline(false);
              }}
            >
              Next
              <i
                className='ri-arrow-right-line align-middle ms-2'
                aria-hidden='true'
              ></i>
            </ActionButton>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={modal_togSecond}
        toggle={tog_togSecond}
        id='decline-reason-modal'
        centered
        style={{ maxWidth: modalWidth }}
        className='custom-modal-width'
      >
        <ModalHeader toggle={() => setmodal_togSecond(false)} />
        <ModalBody>
          <Col sm={12}>
            <Row>
              <Row className='justify-content-center mb-1'>
                <Col lg={12} className='text-center'>
                  <h5>Decline Invitation</h5>
                </Col>
              </Row>
              <Col lg={12}>
                <div className='mb-2 bor border-top border-top-dashed'></div>
              </Col>
              <Col sm={12}>
                <div>
                  <Label htmlFor='reasonDecline' className='form-label'>
                    Please provide your reason for rejecting this
                    invitation:{' '}
                  </Label>
                  <textarea
                    className='form-control'
                    id='reasonDecline'
                    name='reasonDecline'
                    rows='5'
                    value={declineReasonFormData.reasonDecline || ''}
                    onChange={handleInputTextChange}
                  />
                </div>
              </Col>
            </Row>
          </Col>
        </ModalBody>
        <ModalFooter className='text-center'>
          <ActionButton
            variant='secondary'
            icon='ri-close-line'
            className='ms-2'
            onClick={() => setmodal_togSecond(false)}
          >
            Cancel
          </ActionButton>
          <ActionButton
            variant='destructive'
            confirm={false}
            icon='ri-close-line'
            className='ms-2'
            onClick={() => {
              handleConfirmInvitationDecline();
              setmodal_togSecond(false);
            }}
          >
            Decline invitation
          </ActionButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default InvitationForm;
